import React from 'react';

// CSS
import './TallBoyAd.css';

export default class TallBoyAd extends React.Component {

  constructor(props) {
    super(props);

  }

  componentDidMount () {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {

    return (
      <div className={'TallBoyAd TallBoyAd--' + this.props.side}>
        <ins className="adsbygoogle"
            style={{display: 'block'}}
            data-ad-client="ca-pub-1384900650518620"
            data-ad-slot="4925247131"
            data-full-width-responsive="true"></ins>
      </div>
    )

  }

}